import { useState } from 'react';
import { shortenAddress } from '../lib/formatters.js';

export interface TransferButtonProps {
  readonly destination: string;
  readonly disabled?: boolean;
  readonly amountLabel: string;
  readonly onClick: () => Promise<void>;
}

export function TransferButton({
  destination,
  disabled,
  amountLabel,
  onClick,
}: TransferButtonProps) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClick = async (): Promise<void> => {
    setError(null);
    setSubmitting(true);
    try {
      await onClick();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Transfer failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cp-card" aria-label="transfer-card">
      <div className="cp-row" style={{ marginBottom: 12 }}>
        <span style={{ color: 'var(--muted)' }}>Tutar</span>
        <span className="cp-mono">{amountLabel}</span>
      </div>
      <div className="cp-row" style={{ marginBottom: 12 }}>
        <span style={{ color: 'var(--muted)' }}>Hedef</span>
        <span className="cp-mono" title={destination}>
          {shortenAddress(destination)}
        </span>
      </div>
      <button
        type="button"
        className="cp-button"
        onClick={handleClick}
        disabled={disabled || submitting}
      >
        {submitting ? 'İmzalanıyor…' : 'İlet'}
      </button>
      {error ? <div className="cp-error">{error}</div> : null}
    </div>
  );
}
